<app-help-page mainVideo="cycle-report"
               [tutorials]="['cycle-reports', 'dimension-picker', 'adloop-calendar', 'adloop-filters', 'step-report-creation', 'optimization-process', 'cookie-consent']"
               [videos]="['cycle-report', 'filters-orders-report', 'report-saving-sharing', 'report-templates', 'transaction-id-report', 'path-explorer-report']"></app-help-page>
